"use client";

import { useEffect, useRef, useState } from "react";

export default function FadeIn({
    children,
    delay = 0,
    className = "",
}: {
    children: React.ReactNode;
    delay?: number;
    className?: string;
}) {
    const ref = useRef<HTMLDivElement>(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    observer.unobserve(entry.target);
                }
            },
            {
                threshold: 0.1, // Trigger when 10% of the element is visible
                rootMargin: "0px",
            }
        );

        if (ref.current) {
            observer.observe(ref.current);
        }

        return () => observer.disconnect();
    }, []);

    return (
        <div
            ref={ref}
            // "Hareketi azalt" tercihi olan ziyaretcide icerik animasyonsuz gorunur.
            className={`transition-all duration-700 ease-out transform motion-reduce:transition-none motion-reduce:!translate-y-0 motion-reduce:!opacity-100 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
                } ${className}`}
            style={{ transitionDelay: `${delay}ms` }}
        >
            {children}
        </div>
    );
}
